import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router';
import { useMe } from './api/auth';
import { LoginPage } from './pages/LoginPage';
import { AppShell } from './layout/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { UptimePage } from './pages/UptimePage';
import { SitesPage } from './pages/SitesPage';
import { SiteDetailPage } from './pages/SiteDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { FindingsPage } from './pages/FindingsPage';
import { VulnerabilityPage } from './pages/VulnerabilityPage';

/** Chránené cesty: bez relácie presmeruje na /login a zapamätá si, kam chcel používateľ ísť. */
function RequireSession() {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) return <div className="grid h-full place-items-center text-faint">Načítavam…</div>;
  if (!me.data) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return <Outlet />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireSession />}>
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="sites/:id" element={<SiteDetailPage />} />
          <Route path="vulnerabilities" element={<FindingsPage />} />
          <Route path="vulnerabilities/:findingId" element={<VulnerabilityPage />} />
          <Route path="uptime" element={<UptimePage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
